<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
import { useBannerStore } from "@/stores/bannerStore";

/**
 * Load global data once when the app boots
 */
const bannerStore = useBannerStore();

onMounted(() => {
  bannerStore.loadBanners();
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
